import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../configs/store';
import Form  from '../../Form/Form';

interface ResetPasswordProps {
  changedPassword: boolean,
  setChangePassword: () => void,
  close: () => void,
  passwordStrength: { minLength: number, maxLength: number, minStrength: number }
}

function ResetPassword({ close }: ResetPasswordProps) {
  const { t } = useTranslation('common');
  const history = useHistory();
  const { changedPassword } = useSelector((state: RootState) => state.auth);
  const { passwordStrength } = useSelector((state: RootState) => state.content);
  const dispatch = useDispatch();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token');

    if (token === null) {
      history.push('/sports-betting/prematch');
    }

    if (changedPassword) {
      dispatch.auth.setChangePassword(false);

      history.push('/');
    }
  }, [changedPassword]); // eslint-disable-line react-hooks/exhaustive-deps

  const steps = [
    {
      inputs: [
        {
          type: 'password',
          className: 'full-width',
          label: t('form.passwordLabel'),
          name: 'password',
          rules: {
            required: true,
            strength: passwordStrength.minStrength,
            min: passwordStrength.minLength,
            max: passwordStrength.maxLength
          }
        },
        {
          type: 'password',
          className: 'full-width',
          label: t('form.confirmPasswordLabel'),
          name: 'confirmPassword',
          rules: {
            required: true
          }
        }
      ],
      buttons: [
        {
          type: 'submit',
          label: t('form.ok')
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="resetPassword-form"
      steps={ steps }
      close={ close }
    />
  );
}

export default ResetPassword;
